import { FeatureFlags } from "@utils/FeatureFlags/generated-flags";
import { useFlags } from "launchdarkly-react-client-sdk";

import { useIsQaScannerEnabled } from "@components/QaReview/hooks/useIsQaScannerEnabled";
import { useReportOptional } from "@providers/ReportProvider";

export const useIsPeerReviewEnabled = (): boolean => {
  const flags = useFlags<FeatureFlags>();
  const isQaScannerEnabled = useIsQaScannerEnabled();
  const reportData = useReportOptional();

  return !!flags["report-peer-review"] && isQaScannerEnabled && !!reportData?.report.organization?.peerReviewEnabled;
};
